import { JetView } from "webix-jet";
import AddNewMenu from "views/addmenu";

export default class SideBarView extends JetView {
	config() {
		const _ = this.app.getService("locale")._;
		this.WithRoles = this.app.config.roles;

		const newButton = {
			view: "button",
			localId: "add-button",
			css: "webix_primary",
			type: "icon",
			icon: "wxi-plus",
			label: _("New"),
			click: function() {
				this.$scope.Menu.Show(this.$view);
			},
		};

		let menuItems = [
			{ id: "users", value: _("Users"), icon: "umi-users" },
			{ id: "roles", value: _("Roles"), icon: "umi-roles" },
			{ id: "rules", value: _("Rules"), icon: "umi-rules" },
		];
		if (!this.WithRoles) menuItems.splice(1, 1);

		const bar = {
			select: true,
			width: 210,
			view: "list",
			css: "webix_um_sidebar_menu",
			localId: "menu",
			click: id => this.ShowPage(id),
			type: {
				height: webix.skin.$active.listItemHeight + 8,
			},
			data: menuItems,
			template: "<span class='webix_icon #icon#'></span>#value#",
		};

		return {
			css: "webix_um_sidebar",
			type: "clean",
			rows: [
				{
					paddingX: 15,
					paddingY: 15,
					type: "form",
					rows: [newButton],
				},
				bar,
			],
		};
	}

	init() {
		this.Menu = this.ui(AddNewMenu);
		this.on(this.app, "onAddButtonClick", target => this.Menu.Show(target));
	}

	urlChange() {
		const page = this.getUrl()[1].page;
		const mode = page.split(".")[0];
		this.$$("menu").select(mode);
	}

	ShowPage(id) {
		this.show("./" + id);
	}
}
